/**
 * Formats decimal leave hours for display without rounding their stored value.
 * Hours are quantities, not money: locale selects only the presentation
 * separator while the API remains the numeric source of truth.
 */
export function formatHours(value: string | number, locale: string): string | null {
  const raw = typeof value === "string" ? value.trim() : value;
  if (raw === "") return null;

  const numeric = typeof raw === "number" ? raw : Number(raw);
  if (!Number.isFinite(numeric)) return null;

  try {
    return new Intl.NumberFormat(locale, { maximumFractionDigits: 2 }).format(numeric);
  } catch {
    return null;
  }
}
